import { Component, EventEmitter, Input, Output, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { FinancialService } from '../../../../core/services/financial.service';
import { AppButton } from '../../../../shared/components/app-button/app-button';

/** Edit modal for a single row of health_plan_procedures_tb.
 *  Mirrors the FlutterFlow ModalEditHealthPlanProceduresWidget fields —
 *  `percent` (coverage %) is intentionally not editable here: it is only
 *  ever set via the CSV import, matching the source app's behavior. */
@Component({
  selector: 'app-edit-health-plan-procedure-modal',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, TranslateModule, AppButton],
  templateUrl: './edit-health-plan-procedure-modal.component.html',
})
export class EditHealthPlanProcedureModalComponent implements OnChanges {
  @Input() isOpen = false;
  @Input() procedure: any | null = null;
  @Output() close = new EventEmitter<void>();
  @Output() saved = new EventEmitter<void>();

  form: FormGroup;
  loading = false;

  constructor(
    private fb: FormBuilder,
    private financialService: FinancialService,
  ) {
    this.form = this.fb.group({
      internal_code: [''],
      family: ['', Validators.required],
      subfamily: ['', Validators.required],
      group: [''],
      subgroup: [''],
      description: ['', Validators.required],
      base_price: [null, [Validators.required, Validators.min(0)]],
      active: [true],
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['procedure'] && this.procedure) {
      this.form.patchValue({
        internal_code: this.procedure.internal_code,
        family: this.procedure.family,
        subfamily: this.procedure.subfamily,
        group: this.procedure.group,
        subgroup: this.procedure.subgroup,
        description: this.procedure.description,
        base_price: this.procedure.base_price,
        active: this.procedure.active !== false,
      });
    }
  }

  onClose() {
    this.close.emit();
  }

  onSubmit() {
    if (this.form.invalid || !this.procedure?.id) return;

    this.loading = true;
    this.financialService.updateHealthPlanProcedure(this.procedure.id, this.form.value).subscribe({
      next: () => {
        this.loading = false;
        this.saved.emit();
      },
      error: (err) => {
        console.error('Error updating health plan procedure:', err);
        this.loading = false;
      },
    });
  }
}
